import PageLoadedQueue from "./PageLoadedQueue";
import {Modal} from "bootstrap";

PageLoadedQueue.addFunction(() => {
    const breadcrumbItems = document.querySelectorAll('.breadcrumb-item');

    if (breadcrumbItems) {
        breadcrumbItems.forEach((item: HTMLElement, index) => {
            const modalEl = item.querySelector('.modal');

            if (!modalEl) {
                return
            }
            const modal = Modal.getOrCreateInstance(modalEl);

            const button = item.querySelector('[data-bs-toggle="modal"]');

            button?.addEventListener('touchend', (e) => {
                e.preventDefault();
                modal.show();
            });
        });
    }
})
